<!--驾驶员自检记录查询-->
<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('driverSelfCheck.page_title') }}</span>
            <el-form :inline="true" :size="size" style="flex:1;text-align: right;">
                <el-form-item :label="$t('time.timeQuery')">
                    <el-date-picker v-model="date" type="daterange" align="right" style="width: 280px;"
                        :range-separator="$t('time.to')" :picker-options="datePickerOptions"
                        :start-placeholder="$t('time.startDate')" :end-placeholder="$t('time.endDate')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('driverSelfCheck.driver_name') + '：'">
                    <el-input clearable v-model="form.DriverName" style="width: 180px;"
                        :placeholder="$t('driverSelfCheck.please_driver_name')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('driverSelfCheck.risk_level') + '：'">
                    <el-select clearable v-model="form.RiskLevel" style="width: 140px;"
                        :placeholder="$t('public.all')">
                        <el-option :label="$t('public.all')" value=""></el-option>
                        <el-option :label="$t('driverSelfCheck.risk_none')" :value="0"></el-option>
                        <el-option :label="$t('driverSelfCheck.risk_low')" :value="1"></el-option>
                        <el-option :label="$t('driverSelfCheck.risk_high')" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">{{ $t("public.query") }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onExportClick">{{ $t('public.export') }}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="page_container">
            <el-table v-loading="loading" :size="size" height="calc(100vh - 280px)" :data="tableData" border
                style="width: 100%" @row-dblclick="handleDetail">
                <el-table-column type="index" align="center" width="60" :label="$t('public.index')">
                </el-table-column>
                <el-table-column prop="DriverName" align="center" :label="$t('driverSelfCheck.driver_name')"
                    min-width="120">
                </el-table-column>
                <el-table-column prop="CheckTime" align="center" :label="$t('driverSelfCheck.check_time')"
                    min-width="180">
                </el-table-column>
                <el-table-column align="center" :label="$t('driverSelfCheck.temperature')" min-width="140">
                    <template slot-scope="scope">
                        <span :class="tempClass(scope.row.TempLevel)">{{ tempText(scope.row) }}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('driverSelfCheck.risk_level')" min-width="120">
                    <template slot-scope="scope">
                        <el-tag :type="riskTagType(scope.row.RiskLevel)" size="small">
                            {{ riskText(scope.row.RiskLevel) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column align="center" :label="$t('public.Operation')" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDetail(scope.row)">
                            {{ $t('public.Detail') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <kl-pagination style="margin-bottom: 10px;" :total="total" @current-change="pageChange"
                :current-page.sync="form.PageNo" @size-change="sizeChange">
            </kl-pagination>

        </div>

        <!-- 详情弹窗 -->
        <self-check-detail-dialog :visible.sync="detailVisible" :record="currentRow"></self-check-detail-dialog>
    </div>
</template>

<script>
import * as XLSX from 'xlsx'
import SelfCheckDetailDialog from './SelfCheckDetailDialog.vue'

export default {
    name: 'driverSelfCheck',
    components: {
        SelfCheckDetailDialog
    },
    data() {
        return {
            date: [],
            loading: false,
            form: {
                BeginTime: "",
                EndTime: "",
                DriverName: "",
                RiskLevel: "",
                PageNo: 1,
                PageSize: 10
            },
            tableData: [],
            total: 0,
            datePickerOptions: {
                disabledDate(date) {
                    return date > new Date(new Date().getTime())
                }
            },
            detailVisible: false,
            currentRow: {}
        }
    },
    computed: {
        size() {
            return this.$store.getters.size
        }
    },
    methods: {
        sizeChange(size) {
            this.form.PageSize = size;
            this.queryList();
        },
        pageChange(page) {
            this.form.PageNo = page;
            this.queryList();
        },
        init() {
            //查询日期，最近7天
            var now = this.moment();
            var prev = this.moment().subtract(7, 'days');
            this.date = [prev, now];
        },
        queryList() {
            this.loading = true;
            this.$api.queryInspectionRecordByTime({
                DriverName: this.form.DriverName,
                BeginTime: this.form.BeginTime,
                EndTime: this.form.EndTime,
                RiskLevel: this.form.RiskLevel,
                PageNo: this.form.PageNo,
                PageSize: this.form.PageSize
            }).then(res => {
                this.loading = false;
                if (res && res.code == 200) {
                    this.tableData = this.mapRecords(res.data || []);
                    this.total = res.recordsTotal || this.tableData.length;
                }
            }).catch(() => {
                this.loading = false;
            });
        },
        // 将接口返回字段映射为页面展示字段
        mapRecords(list) {
            return (list || []).map(item => {
                return {
                    RecordID: item.RecordID,
                    DriverName: item.DriverName,
                    CheckTime: item.CreateTime,
                    TempLevel: item.Temp_ID,
                    Temperature: item.TempValue,
                    ColdSymptoms: item.ColdSymptom_ID,
                    FatiguePain: item.FatiguePain_ID,
                    SpecialAbnormal: item.SpecialAbnormal_ID,
                    OtherDesc: item.OtherDescription,
                    RiskLevel: item.RiskLevel,
                    DrivingRisk: item.DrivingRisk,
                    RiskDescription: item.RiskDescription,
                    SuggestedActions: item.SuggestedActions
                };
            });
        },
        onSubmit() {
            if (!this.date || this.date.length < 2) {
                this.$message.warning(this.$t('driverSelfCheck.please_select_date'));
                return;
            }
            this.form.BeginTime = this.moment(this.date[0]).format('YYYY-MM-DD 00:00:00')
            this.form.EndTime = this.moment(this.date[1]).format('YYYY-MM-DD 23:59:59')
            this.form.PageNo = 1;
            this.queryList();
        },
        handleDetail(row) {
            this.currentRow = row || {};
            this.detailVisible = true;
        },
        onExportClick() {
            if (!this.date || this.date.length < 2) {
                this.$message.warning(this.$t('driverSelfCheck.please_select_date'));
                return;
            }
            this.loading = true;
            this.$api.queryInspectionRecordByTime({
                DriverName: this.form.DriverName,
                BeginTime: this.form.BeginTime,
                EndTime: this.form.EndTime,
                RiskLevel: this.form.RiskLevel,
                PageNo: 1,
                PageSize: 65535
            }).then(res => {
                this.loading = false;
                if (!res || res.code != 200 || !res.data || res.data.length === 0) {
                    this.$message.warning(this.$t('driverSelfCheck.no_data_export'));
                    return;
                }
                this.exportToExcel(this.mapRecords(res.data));
                this.$message.success(this.$t('driverSelfCheck.export_success'));
            }).catch(() => {
                this.loading = false;
            });
        },
        //体温等级文案：0=正常 1=低热 2=中高热
        tempLevelText(level) {
            const map = ['temp_normal', 'temp_low_fever', 'temp_high_fever'];
            const key = map[level-1] || 'temp_normal';
            return this.$t('driverSelfCheck.' + key);
        },
        tempText(row) {
            const levelTxt = this.tempLevelText(row.TempLevel);
            if (row.Temperature != null && row.Temperature !== '' && row.Temperature !== undefined && Number(row.Temperature) > 0) {
                // 修正浮点数精度，保留一位小数
                const temp = Math.round(Number(row.Temperature) * 10) / 10;
                return levelTxt + ' ' + temp + '℃';
            }
            return levelTxt;
        },
        tempClass(level) {
            if (level == 3) return 'temp-high';
            if (level == 2) return 'temp-low';
            if (level == 1) return 'temp-normal';
            return 'temp-normal';
        },
        //风险等级文案：0/1=低风险 2=中风险 3+=高风险
        riskText(level) {
            if (level >= 2) return this.$t('driverSelfCheck.risk_high');
            if (level == 1) return this.$t('driverSelfCheck.risk_low');
            if (level == 0) return this.$t('driverSelfCheck.risk_none');
            return this.$t('driverSelfCheck.risk_none');
        },
        riskTagType(level) {
            if (level >= 2) return 'danger';
            if (level == 1) return 'warning';
            if (level == 0) return 'success';
            return 'success';
        },
        exportToExcel(list) {
            const header = [
                this.$t('driverSelfCheck.driver_name'),
                this.$t('driverSelfCheck.check_time'),
                this.$t('driverSelfCheck.temperature'),
                this.$t('driverSelfCheck.risk_level')
            ];
            const rows = list.map(item => [
                item.DriverName || '',
                item.CheckTime || '',
                this.tempText(item),
                this.riskText(item.RiskLevel)
            ]);
            const aoa = [header, ...rows];
            const ws = XLSX.utils.aoa_to_sheet(aoa);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, this.$t('driverSelfCheck.page_title'));
            const fileName = this.$t('driverSelfCheck.page_title') +
                this.moment(new Date()).format('YYYY-MM-DD') + '.xlsx';
            XLSX.writeFile(wb, fileName);
        }
    },
    mounted() {
        this.init();
        this.onSubmit();
    }
}
</script>
<style scoped>
.temp-normal {
    color: #67c23a;
}

.temp-low {
    color: #e6a23c;
}

.temp-high {
    color: #f56c6c;
}
</style>
